import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'AUTOMATIC_EMAIL' });



// WEBPACK FOOTER //
// ./src/frontend/modules/email/automatic-sending/handlers.js